import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CommonStateService } from 'projects/suche-lib/src/lib/services/state/common-state.service';
import { SuchwortService } from 'projects/suche-lib/src/lib/services/suchseite/suchwort.service';
import { CleanupService } from 'projects/suche-lib/src/lib/shared/utils/cleanup.service';
import { firstValueFrom, takeUntil } from 'rxjs';
import { SucheComponent as SucheComponent_1 } from '../../../../../suche-lib/src/lib/pages/suche/suche.component';
import { UrlService } from '../../../../../suche-lib/src/lib/services/state/url.service';
import { PaginationService } from '../../../../../suche-lib/src/lib/services/suchseite/pagination.service';
import { RobotsService } from '../../service/robots.service';

@Component({
  selector: 'now-wbsuche-app-suche',
  templateUrl: './suche.component.html',
  providers: [CleanupService],
  imports: [SucheComponent_1]
})
export class SucheComponent implements OnInit, OnDestroy {
  private readonly commonStateService = inject(CommonStateService);
  private readonly urlService = inject(UrlService);
  protected readonly paginationService = inject(PaginationService);
  private readonly robotsService = inject(RobotsService);

  public shouldScrollToHeader = true;

  constructor() {
    const cleanupService = inject(CleanupService);
    const suchwortService = inject(SuchwortService);
    const title = inject(Title);

    suchwortService.suchwort$.pipe(takeUntil(cleanupService.destroyed$)).subscribe((suchwort) => {
      title.setTitle(
        suchwort
          ? `Weiterbildungssuche: ${suchwort} | mein NOW`
          : 'Weiterbildungssuche: passende Angebote suchen & finden | mein NOW'
      );
    });

    // NOWSUCHE-3991 Suchergebnislisten sollen nur bei Treffern in Suchmaschinen indexiert werden,
    //               ohne Treffer NICHT, um Spam zu reduzieren.
    this.paginationService.pageInfos$
      .pipe(takeUntil(cleanupService.destroyed$))
      .subscribe((pageInfos) => {
        if (pageInfos && pageInfos.totalResults > 0) {
          this.robotsService.setIndexFollow();
        } else {
          this.robotsService.setNoIndexNoFollow();
        }
      });
  }

  private async initScrollPosition() {
    const angebotId = await firstValueFrom(this.commonStateService.selectedAngebotId$);
    if (angebotId) {
      this.shouldScrollToHeader = false;
    }
  }

  ngOnInit() {
    this.initScrollPosition();

    //  NOWSUCHE-3991 Startseite ohne parameter indexieren - geht das hier am besten?!
    this.robotsService.setIndexFollow();
  }

  ngOnDestroy(): void {
    this.robotsService.setNoIndexNoFollow();
  }

  public zeigeDetailseite(terminId: string): void {
    this.urlService.updateUrl(null, `termin/${terminId}`);
  }
}
